import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-rose-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-pink-300 via-orange-200 to-rose-300 text-white py-32" style={{ background: 'linear-gradient(135deg, #ffa7cd 0%, #ffb347 50%, #ff8fab 100%)' }}>
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/a6e78acd1cac5744f2e0fc2fab47e7f3.jpg')`
          }}
        ></div>
        <div className="relative max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* タイトル */}
            <div className="text-center md:text-left">
              <div className="flex flex-col items-center md:items-start mb-8">
                <h1 className="text-4xl md:text-5xl font-bold mb-4">
                  重度心身障害児のための
                  <br />
                  放課後等デイサービス「てとて」
                </h1>
              </div>
              <p className="text-xl md:text-2xl mb-8 opacity-90">
                助け合いながら福祉の輪を広げていく
              </p>
              <Link
                to="/donation"
                className="inline-block bg-white px-12 py-6 rounded-full font-bold text-xl hover:bg-gray-100 transition-all duration-300 whitespace-nowrap shadow-lg"
                style={{ color: '#ff8fab' }}
              >
                <i className="ri-heart-line mr-3"></i>
                支援・寄付のお申込み
              </Link>
            </div>
            
            {/* 右側のコラボレーション情報 */}
            <div className="text-center">
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8">
                <div className="text-center">
                  <h3 className="text-2xl font-bold mb-4">福祉車両×企業のコラボで</h3>
                  <h3 className="text-3xl font-bold mb-6">社会貢献</h3>
                  <p className="text-lg opacity-90 leading-relaxed mb-4">
                    企業様の広告掲載を通じて<br />
                    持続可能な福祉事業を実現
                  </p>
                  <p className="text-base opacity-85 leading-relaxed">
                    福祉車両のラッピングAD宣伝を通じて<br />
                    社会貢献の支援の最大のリターン
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 事業所案内セクション */}
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <div className="flex justify-center items-center mb-8">
            <img 
              src="https://static.readdy.ai/image/d740e2b34c55af2f7b572916836ca234/e12563d933ea14c3e7a230f8f632e751.png" 
              alt="てとて ロゴ" 
              className="w-32 h-32 mr-8"
            />
            <h2 className="text-4xl font-bold text-gray-800">
              なぜ看護師の私が立ち上がるのか
            </h2>
          </div>
        </div>

        {/* 自己紹介セクション */}
        <div className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-12 border-t-4" style={{ borderTopColor: '#ffb347' }}>
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">こんにちは。私のページをご覧いただき、ありがとうございます。</h3>
            </div>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                私は、<strong>Wa-international</strong>という一般社団法人を立ち上げに挑戦しています。その最初の福祉医療の事業形態として、愛知県名古屋市緑区周辺で重度心身障害児の受け入れを対象とする放課後等デイサービス<strong>「てとて」</strong>の開設を目指して活動しております。
              </p>
              
              <p>
                看護師免許を取得して10年以上が経ちました。幼い頃より海外での生活に憧れがあり、看護師免許取得後すぐにニュージーランドへワーキングホリデーで渡航しました。
              </p>
              
              <div className="bg-gradient-to-r from-orange-50 to-pink-50 border-l-4 p-6 my-8" style={{ borderLeftColor: '#ffb347' }}>
                <p className="text-orange-700">
                  多民族が共存するニュージーランドで学んだのは、自分のライフスタイルやアイデンティティを大切にすることでした。<strong>職種やマイノリティーに関わらず、一人ひとりが個人として人生を楽しむこと</strong>—これが今の私のルーツとなっています。
                </p>
              </div>
              
              <p>
                コロナが深刻になったタイミングで日本に帰国し、はや5年以上が経ちました。帰国後は整形外科分野のみならず、最先端医療分野の再生医療や終活といわれる介護施設等にも勤務し、幅広い医療・福祉の現場を経験してきました。
              </p>
              
              <p>
                様々な現場で働く中で、制度の隙間で困っている人たちの存在に気づくようになりました。特に重度心身障害児を支える家族の現実を知るにつれ、<strong>ニュージーランドで学んだ「一人ひとりが人生を楽しむ権利」が、日本では十分に保障されていない</strong>ことを痛感しました。
              </p>
              
              <p>
                ただ、<strong>私がいち従業員として働き続ける限り何も変わらない。</strong>
              </p>
              
              <p>
                そう思っていた時に、たまたま目に留まったのが<strong>医療的ケア児のママさんが綴ったSNSでの投稿</strong>でした。
              </p>
            </div>
          </div>
        </div>

        {/* 「てとて」の由来セクション */}
        <div className="mb-16">
          <div className="bg-gradient-to-br from-pink-100 via-orange-50 to-pink-50 rounded-2xl p-12">
            <div className="text-center mb-8">
              <div className="flex justify-center items-center mb-6">
                <img 
                  src="https://static.readdy.ai/image/d740e2b34c55af2f7b572916836ca234/e12563d933ea14c3e7a230f8f632e751.png" 
                  alt="てとて ロゴ" 
                  className="w-24 h-24 mr-6"
                />
                <h3 className="text-3xl font-bold" style={{ color: '#d63384' }}>「てとて」の由来</h3>
              </div>
            </div>
            
            <div className="space-y-6 text-lg leading-relaxed" style={{ color: '#d63384' }}>
              <p>
                看護学生時代に看護理論を学んでいるとき、看護理論を呈した第一人者の<strong>ナイチンゲール</strong>は看護師の手が持つ<strong>「癒しの力」</strong>について言及しています。
              </p>
              
              <p>
                彼女は手による触れ合いが単なる医療技術だけでなく、患者に安心感と信頼をもたらす要素であると唱え、それが私が看護をするときの理念となっています。
              </p>
              
              <div className="bg-white/60 rounded-xl p-6 text-center">
                <p className="text-xl font-semibold mb-4">
                  みなさんは痛いところに優しく手を当てると、不思議と心も体も少し楽になる、あの感覚を覚えていますか。
                </p>
                <p className="text-lg">
                  これが<strong>「手当て」</strong>の原点であり<br />
                  <span className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>『てとて』</span>という事業所名の由来となっています。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* プロジェクト立ち上げきっかけセクション */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
              プロジェクトを立ち上げたきっかけ
            </h2>
            <h3 className="text-2xl font-bold" style={{ color: '#ff8fab' }}>
              あのママさんのSNSでの投稿が私の人生を変えた
            </h3>
          </div>
          
          <div className="bg-white rounded-2xl shadow-lg p-12 border-t-4" style={{ borderTopColor: '#ff8fab' }}>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                深夜０時、スマホの画面に映ったその投稿に、私は言葉を失いました。
              </p>
              
              <div className="bg-gray-50 border-l-4 p-6 my-8" style={{ borderLeftColor: '#ff8fab' }}>
                <p className="text-gray-800 font-semibold italic text-xl leading-relaxed">
                  「13年間、24時間年中無休で命と戦ってきた生活。睡眠時間は4-5時間。朝までぐっすり寝る時間はなかった。外出するには2-3時間の準備が必要で、いつでも病院へ走れるよう飲酒もやめた。」
                </p>
              </div>
              
              <p>
                ある医療的ケア児のママさんが綴った、13年間の壮絶な日々。お子さんは残念ながら亡くなられましたが、その後このママさんは「医療的ケア児に関わる仕事への社会復帰」を目指されています。
              </p>
              
              <p>
                その投稿を読みながら、私は自分自身に問いかけていました。
              </p>
              
              <div className="space-y-3 ml-6">
                <p className="text-orange-700">
                  <i className="ri-question-line mr-2"></i>
                  「私が生まれた子にすぐにケアできる気持ち、受け入れることはできるだろうか？」
                </p>
                <p className="text-orange-700">
                  <i className="ri-question-line mr-2"></i>
                  「自分のライフスタイルを子どものために変容し、すべてをささげて24時間無休のケアに当たることはできるのだろうか？」
                </p>
              </div>
              
              <p>
                そして、<strong style={{ color: '#ff8fab' }}>強い憤りと決意が湧き上がりました。</strong>
              </p>
              
              <div className="bg-gradient-to-r from-orange-50 to-pink-50 border-l-4 p-6 my-8" style={{ borderLeftColor: '#ffb347' }}>
                <p className="text-xl font-bold text-orange-700">
                  「もっと福祉サービスが充実していたら、もっと前向きにケアに当たることができたのではないか。現状を変えたい！」
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 見過ごされる現実セクション */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
              見過ごされる現実
            </h2>
          </div>
          
          <div className="bg-white rounded-2xl shadow-lg p-12 border-t-4" style={{ borderTopColor: '#ffa7cd' }}>
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                インスタグラムで重心児の家族と繋がるようになってから、私は知らなかった現実を目の当たりにしました。
              </p>
              
              <div className="grid md:grid-cols-3 gap-6 my-8">
                <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-6 text-center">
                  <div className="text-3xl font-bold mb-2" style={{ color: '#d63384' }}>2-3時間</div>
                  <p className="text-gray-700">夜間の吸痰で眠れない日々</p>
                </div>
                <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-xl p-6 text-center">
                  <div className="text-3xl font-bold mb-2 text-orange-600">週4日</div>
                  <p className="text-gray-700">学校、受診、リハビリで埋まるスケジュール</p>
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-xl p-6 text-center">
                  <div className="text-3xl font-bold mb-2" style={{ color: '#ff8fab' }}>当たり前</div>
                  <p className="text-gray-700">児の体調に左右され、個人のスケジュールはドタキャン</p>
                </div>
              </div>
              
              <div className="bg-red-50 border-l-4 border-red-400 p-6 my-8">
                <h4 className="font-bold mb-3 text-red-700">心痛む事件の背景</h4>
                <p className="text-red-700 mb-4">
                  そして最近、全国ニュースで心痛む事件が報道されました。医療的ケア児の母親が疲弊し、子どもの呼吸器を外してしまった事件。
                </p>
                <p className="text-red-700 font-semibold">
                  「自分も子どもも必要とされていない」と感じ、命を絶とうとした母親の心の叫び。
                </p>
              </div>
              
              <p className="text-xl font-bold" style={{ color: '#d63384' }}>
                この事件の背景には、確実にサービス不足があります。サービスへのアクセスが限られ、社会参加の機会が少なく、介護ストレスが限界に達してしまう。これが、重心児を支える家族の現実なのです。
              </p>
            </div>
          </div>
        </div>

        {/* 名古屋市の深刻な現状 */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-8 text-gray-800">
              名古屋市の深刻な現状
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center border-t-4" style={{ borderTopColor: '#ffb347' }}>
              <div className="text-5xl font-bold mb-4" style={{ color: '#ff8fab' }}>230万</div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">名古屋市人口</h3>
              <p className="text-gray-600">
                大都市でありながら重症心身障害児向けサービスが不足
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 text-center border-t-4" style={{ borderTopColor: '#ffa7cd' }}>
              <div className="text-5xl font-bold mb-4" style={{ color: '#ffb347' }}>&lt;10</div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">重心型施設数</h3>
              <p className="text-gray-600">
                16区に対してわずか10施設未満という圧倒的な不足
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 text-center border-t-4" style={{ borderTopColor: '#ff8fab' }}>
              <div className="text-5xl font-bold mb-4" style={{ color: '#d63384' }}>24/7</div>
              <h3 className="text-xl font-bold mb-3 text-gray-800">親御さんのケア</h3>
              <p className="text-gray-600">
                24時間365日休むことなく続く親御さんの献身的なケア
              </p>
            </div>
          </div>
        </div>

        {/* 革新的な支援モデル */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-8 text-gray-800">
            革新的な支援モデル
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto mb-12">
            企業様には福祉車両への広告掲載を通じて、CSR活動とマーケティングを両立していただけます。
            これにより、持続可能な福祉事業の実現とSDGs・地域活性化に貢献できます。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-gradient-to-br from-pink-100 via-orange-50 to-pink-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#d63384' }}>
              <i className="ri-car-line mr-3"></i>
              企業スポンサーシップ
            </h3>
            <div className="space-y-4 mb-6">
              <div className="flex items-start">
                <i className="ri-check-double-line mt-1 mr-3 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <span style={{ color: '#d63384' }}>福祉車両への広告掲載（3〜6ヶ月）</span>
              </div>
              <div className="flex items-start">
                <i className="ri-check-double-line mt-1 mr-3 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <span style={{ color: '#d63384' }}>事業所看板への企業名永年掲載</span>
              </div>
              <div className="flex items-start">
                <i className="ri-check-double-line mt-1 mr-3 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <span style={{ color: '#d63384' }}>事業所案内パンフレットへの企業名掲載</span>
              </div>
              <div className="flex items-start">
                <i className="ri-check-double-line mt-1 mr-3 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <span style={{ color: '#d63384' }}>定期的な活動報告書の送付</span>
              </div>
            </div>
            
            {/* 福祉車両広告掲載の参考イメージ */}
            <div className="bg-white/60 rounded-xl p-4 border-l-4 mb-4" style={{ borderLeftColor: '#ffb347' }}>
              <h4 className="font-bold mb-3" style={{ color: '#d63384' }}>
                <i className="ri-car-line mr-2"></i>
                福祉車両広告掲載イメージ
              </h4>
              <div className="mt-4">
                <img 
                  src="https://static.readdy.ai/image/d740e2b34c55af2f7b572916836ca234/a1ce1198134f78d9d94b1fa2973ffd4d.png" 
                  alt="福祉車両への広告掲載イメージ" 
                  className="w-full h-[600px] object-cover object-center rounded-lg shadow-md border-2 border-pink-200"
                />
                <p className="text-xs text-center mt-2 text-gray-600">
                  ※実際の福祉車両への企業広告掲載イメージ
                </p>
              </div>
            </div>
            
            {/* 事業所看板の参考イメージ */}
            <div className="bg-white/60 rounded-xl p-4 border-l-4 mb-4" style={{ borderLeftColor: '#ffb347' }}>
              <h4 className="font-bold mb-3" style={{ color: '#d63384' }}>
                <i className="ri-store-line mr-2"></i>
                事業所看板掲載イメージ
              </h4>
              <div className="mt-4">
                <img 
                  src="https://static.readdy.ai/image/d740e2b34c55af2f7b572916836ca234/b170d198787fae4ccd42cf9ed2b21c01.png" 
                  alt="事業所看板への企業名掲載イメージ" 
                  className="w-full h-[600px] object-cover object-center rounded-lg shadow-md border-2 border-pink-200"
                />
                <p className="text-xs text-center mt-2 text-gray-600">
                  ※実際の事業所看板への企業名掲載イメージ
                </p>
              </div>
            </div>
            
            {/* パンフレット掲載位置の詳細説明 */}
            <div className="bg-white/60 rounded-xl p-4 border-l-4" style={{ borderLeftColor: '#ffb347' }}>
              <h4 className="font-bold mb-3" style={{ color: '#d63384' }}>
                <i className="ri-file-text-line mr-2"></i>
                パンフレット掲載位置詳細
              </h4>
              <div className="space-y-2 text-sm" style={{ color: '#d63384' }}>
                <div className="flex items-center">
                  <i className="ri-arrow-right-s-line mr-2" style={{ color: '#ffb347' }}></i>
                  <span>事業所概要ページ下部「こちらに事業・企業名役職」欄へ掲載</span>
                </div>
              </div>
            </div>
            
            {/* パンフレット参考画像 */}
            <div className="mt-4">
              <img 
                src="https://static.readdy.ai/image/d740e2b34c55af2f7b572916836ca234/c24b6ff76fac72423669d36bf7d121ae.png" 
                alt="事業所案内パンフレット参考例" 
                className="w-full rounded-lg shadow-md border-2 border-pink-200"
              />
              <p className="text-xs text-center mt-2 text-gray-600">
                ※実際のパンフレットへの企業名掲載イメージ
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-100 to-yellow-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-6 text-orange-800">
              <i className="ri-heart-line mr-3"></i>
              社会貢献効果
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-leaf-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-orange-700">SDGs目標3「すべての人に健康と福祉を」</span>
              </div>
              <div className="flex items-start">
                <i className="ri-leaf-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-orange-700">地域の福祉インフラ整備への貢献</span>
              </div>
              <div className="flex items-start">
                <i className="ri-leaf-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-orange-700">企業のCSR活動としての価値創出</span>
              </div>
              <div className="flex items-start">
                <i className="ri-leaf-line text-orange-600 mt-1 mr-3 flex-shrink-0"></i>
                <span className="text-orange-700">地域活性化と雇用創出</span>
              </div>
            </div>
          </div>
        </div>

        {/* 約束とお願い */}
        <div className="mb-16">
          <div className="bg-gradient-to-r from-pink-100 via-orange-50 to-rose-100 rounded-2xl p-12">
            <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
              皆様へのお約束
            </h2>
            <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
              <div className="flex items-start">
                <i className="ri-shield-check-line text-2xl mt-1 mr-4 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <p>
                  <strong>今回の支援・寄付は全額すべて開業に当てさせていただきます。</strong>
                  一円たりとも他の用途には使用いたしません。
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-file-list-line text-2xl mt-1 mr-4 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <p>
                  <strong>進捗についても詳細にご報告いたします。</strong>
                  透明性を保ち、支援者の皆様に安心していただけるよう努めます。
                </p>
              </div>
              <div className="flex items-start">
                <i className="ri-hand-heart-line text-2xl mt-1 mr-4 flex-shrink-0" style={{ color: '#ffb347' }}></i>
                <p>
                  事業所名「てとて」の名前にも由来する<strong>助け合いながら福祉の輪が広がっていくこと</strong>を目指していきたいと思っております。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA セクション */}
        <div className="rounded-2xl p-12 text-center text-white" style={{ background: 'linear-gradient(135deg, #ffa7cd 0%, #ffb347 50%, #ff8fab 100%)' }}>
          <h2 className="text-3xl font-bold mb-6">
            子どもたちの笑顔のために、今すぐ行動を
          </h2>
          <p className="text-xl mb-8 opacity-90">
            あなたのご支援が、待っている家族の希望になります
          </p>
          <Link
            to="/donation"
            className="inline-block bg-white px-12 py-4 rounded-full font-bold text-xl hover:bg-gray-100 transition-all duration-300 whitespace-nowrap shadow-lg"
            style={{ color: '#ff8fab' }}
          >
            <i className="ri-hand-heart-line mr-3"></i>
            支援・寄付のお申込み
          </Link>
        </div>
      </div>
    </div>
  );
}
